<template src="./usersPage.html"></template>

<script>
    import usersEndpoints from '../users.endpoints.js';
    import dataTableMixin from '../../../js/dataTableMixin.js';
    import Vue from 'vue';

    export default {
        name: 'users-page',
        mixins: [dataTableMixin],
        data() {
            return {
                dto: {
                    UserType: '', 
                    SearchText: '', 
                    EntityID: -1, 
                    IncludeInactive: false,
                    PageRows: 100,
                    PageNumber: 1,
                    SortByColumn: 'Name',
                    SortDirection: 'asc',
                },
                userTypes: [],
                tabAnimation: { 
                    previous: { 
                        effect: 'None', 
                    },
                    next: { 
                        effect: 'None', 
                    } 
                },
                userTypeNumberOfRecords: [],
                dropdownFields: {
                    text: 'Text',
                    value: 'Value'
                },
				usersTableItems: {},
                usersTableSortBy: {
                    columns: [
                        { field: 'Name', direction: 'Ascending' },
                    ]
                },
                entityRoleColumnTemplate: function() {
                    return {
                        template: Vue.component('entityRoleColumnTemplate', {
                            template: `<div v-html="entityNames"></div>`,
                            computed: {
                                entityNames() {
                                    let html = '';
                                    let length = this.data.EntityRoles.length;
                                    this.data.EntityRoles.forEach((role, index) => {
                                        if (index < 2) {
                                            html += ` 
                                            <div class="dm-flex-row" style="margin-bottom: 2px;">
                                                <div style="width: 200px; margin-right: 10px;">${role.EntityName}</div>
                                                <div class="app-role-badge">${role.RoleName}</div>
                                            </div>`;
                                        }
                                    })

                                    if (length > 2) {
                                        html += `(${length - 2} more)`
                                    }

                                    return html;
                                }
                            },
                        })
                    }
                },
            }
        },
        computed: {
            permissions() {               
                return this.$store.state.PermissionsModule.userPermissions;
            },
            usersTableColumns() {
                let columns = [
                        {
                            type: 'iconTemplate',
                            iconName: 'edit',
                            width: '35px',
                            allowSorting: false 
                        },
                        {
                            key: 'Name',
                            label: 'Name',
                            allowSorting: true
                        },
                        {
                            key: 'Email',
                            label: 'Email',
                            allowSorting: true
                        },
                        {
                            key: 'IsActive',
                            label: 'Status',
                            width: '60px',
                            allowSorting: true,
                            formatter: (column, data) => {
                                return data.IsActive === true ? 'Active' : 'Inactive';
                            }
                        },
                        {
                            key: 'EntityRoles', 
                            label: 'Roles',
                            type: 'template',
                            clipMode: 'EllipsisWithTooltip',
                            allowSorting: true,
                            template: this.entityRoleColumnTemplate,
                        },
                    ];

                if (this.dto.UserType.Value === this.$store.state.PermissionsModule.userTypes.SuperAdmin) {
                    columns = [
                        {
                            type: 'iconTemplate',
                            iconName: 'edit',
                            width: '35px',
                            allowSorting: false 
                        },
                        {
                            key: 'Name',
                            label: 'Name',
                            allowSorting: true
                        },
                        {
                            key: 'Email',
                            label: 'Email',
                            allowSorting: true
                        },
                        {
                            key: 'IsActive',
                            label: 'Status',
                            width: '60px',
                            allowSorting: true,
                            formatter: (column, data) => {
                                return data.IsActive === true ? 'Active' : 'Inactive';
                            }
                        },
                    ];
                } 

                if (!this.permissions.CanUpdate) {
                    columns.shift();
                }

                return columns;
            }
        },
        methods: {
            getNumRecordsForType(type) {
                if (this.userTypeNumberOfRecords.length === 0) {
                    return 0;
                }

                let recordsForType = this.userTypeNumberOfRecords.find((record) => record.UserType === type);
                return recordsForType.NumberOfRecords;
            },
            showTabCountIcon(type) {
                if (this.dto.SearchText === '') {
                    return false;
                }

                if (this.dto.UserType.Value === type) {
                    return false;
                }

                if (this.getNumRecordsForType(type) === 0) {
                    return false;
                }

                return true;
            },
            getDropdownForUserType(type) {
                if (type === this.$store.state.PermissionsModule.userTypes.ProgramOfficer) {
                    return this.$store.dispatch('getProgramOptions');
                }

                if (type === this.$store.state.PermissionsModule.userTypes.Intermediary) {
                    return this.$store.dispatch('getIntermediaryOptions');
                }

                if (type === this.$store.state.PermissionsModule.userTypes.State) {
                    return this.$store.dispatch('getStateOptions');
                }

                if (type === this.$store.state.PermissionsModule.userTypes.System) {
                    return this.$store.dispatch('getSystemOptions');
                }

                if (type === this.$store.state.PermissionsModule.userTypes.Institution) {
                    return this.$store.dispatch('getInstitutionOptions');
                }
            },
            onTabChange(args) {
                this.dto.UserType = this.userTypes[args.selectedIndex];
                this.dto.EntityID = -1;
                this.dto.IncludeInactive = false;
                this.usersTableItems = [];
                
                if (this.dto.UserType.Value=== this.$store.state.PermissionsModule.userTypes.SuperAdmin) {
                    this.getAll();
                } else {
                    return this.getDropdownForUserType(this.dto.UserType.Value)
                        .then(() => {
                            this.getAll();
                        })
                }
            },
            tabSelecting(args) {
                if (args.isSwiped) {
                    args.cancel = true;
                }
            },
            getAll() {
                return usersEndpoints.getAll(this.dto)
                	.then((response) => {
                        this.usersTableItems = [];
                        this.usersTableItems = {
                            result: response.Rows,
                            count: response.NumberOfRecords,
                        }

                        this.userTypeNumberOfRecords = response.UserTypeNumberOfRecords;
                	});         
			},
            create() {
                if (this.permissions.CanCreate) {
                    let modalData = {
                        userType: this.dto.UserType,
                        callback: this.getAll,
                    }
    
                    DMUtils.openApplicationModal('usersPreliminaryModal', modalData);
                }
            },
            update() {
                if (this.permissions.CanUpdate) {
                    let modalData = {
                        mode: 'edit',
                        dto: {},
                        callback: this.getAll,
                    };
    
                    usersEndpoints.getByID(this.selectedRow.rowData.UserID, this.dto.UserType.Value)
                        .then((response) => {
                            modalData.dto = response;
                            modalData.dto.UserType = this.dto.UserType
                    
                            DMUtils.openApplicationModal('usersEditModal', modalData);
                        });
                }
            },
        },
        created() {
            usersEndpoints.getTypes()
                .then((response) => {
                    this.userTypes = response;
                    this.dto.UserType = this.userTypes[0];
                    this.getDropdownForUserType(this.dto.UserType.Value);
                    this.getAll();
                })
        }
    }
</script>
